<template>
  <div class="help">
    <div class="d-flex flex-row-reverse" v-if="!isEditMode">
      <b-button variant="brand-secondary" @click="editDocument">
        Edit
        <i class="icon-edit ml-1"></i>
      </b-button>
    </div>
    <b-card class="mt-3">
      <div class="user-manual">
        <div
          v-if="!isEditMode"
          class="user-manual-content"
          v-html="htmlCode"
        ></div>
        <div v-if="isEditMode" class="user-manual-edit">
          <editor
            :api-key="tinymceApiKey"
            initial-value="Hello"
            v-model="htmlCode"
            :init="{
              height: 660,
              menubar: false,
              branding: false,
              plugins:
                'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
              menubar: 'file edit view insert format tools table help',
              toolbar:
                'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
            }"
          />
        </div>
      </div>
    </b-card>
    <div class="d-flex flex-row-reverse mt-3" v-if="isEditMode">
      <b-button variant="brand-primary" @click="saveDocument"> Save </b-button>
      <b-button
        class="mr-3"
        variant="brand-secondary"
        @click="cancelEditDocument"
      >
        Cancel
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
export default {
  name: "Help",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Help",
  },
  mounted() {
    this.getDocument();
  },
  data() {
    return {
      tinymceApiKey: process.env.VUE_APP_TINYMCE_API_KEY,
      isEditMode: false,
      htmlCode: "",
      OldContent: "",
    };
  },
  methods: {
    ...mapMutations(["setItem"]),
    ...mapActions(["getHelpDocument", "saveHelpDocument"]),
    editDocument() {
      this.isEditMode = true;
      // this.getDocument();
    },
    getDocument() {
      this.setItem({ resource: "isLoading", payload: true });
      this.getHelpDocument(this.currentLngId)
        .then((response) => {
          if (response.length) {
            this.htmlCode = this.OldContent = response[0].content;
          }

          this.setItem({ resource: "isLoading", payload: false });
        })
        .catch(() => {
          this.setItem({ resource: "isLoading", payload: false });
        });
    },
    saveDocument() {
      this.setItem({ resource: "isLoading", payload: true });
      this.saveHelpDocument({
        content: this.htmlCode,
        userId: this.loggedUserId,
        languageId: this.currentLngId,
      })
        .then(() => {
          this.isEditMode = false;
          this.setItem({ resource: "isLoading", payload: false });
          this.getDocument();
        })
        .catch(() => {
          this.setItem({ resource: "isLoading", payload: false });
        });
    },
    cancelEditDocument() {
      this.htmlCode = this.OldContent;
      this.isEditMode = false;
    },
  },
  computed: {
    ...mapGetters(["languages", "selected_language"]),

    currentLngId() {
      let selectedLng = this.languages.find(
        (lng) => lng.languageCode === this.selected_language
      );
      return selectedLng.languageId;
    },
  },
  watch: {
    selected_language() {
      this.getDocument();
    },
  },
};
</script>
